<template>
  <div>
    <v-row class="login-background">
      <v-col cols="2" lg="2" md="1" sm="1"></v-col>
      <v-col cols="8" lg="8" md="10" sm="10" class="d-flex align-center">
        <v-row class="d-flex align-center">
          <v-col cols="6" lg="6" md="5" sm="12" class="d-flex flex-column">
            <div class="ml-2 mr-2" style="margin-bottom: 10%">
              <v-img
                v-if="$vuetify.theme.dark"
                width="45%"
                height="auto"
                src="../../assets/login-logo.svg"
              ></v-img>
              <v-img
                v-else
                width="45%"
                height="auto"
                src="../../assets/login-logo-light.svg"
              ></v-img>
            </div>
            <div class="mb-4 ml-2 mr-2">
              <font
                class="font-bold"
                style="font-size: min(max(20px, 3vw), 48px)"
                :style="$vuetify.theme.dark ? 'color: #FFFFFF;' : 'color: #12083F'"
              >
                Let’s get you<br />
                to the connectivity !
              </font>
            </div>
            <div class="ml-2 mr-2">
              <icon-svg width="9%" iconName="Login Arrow" />
            </div>
          </v-col>
          <v-col cols="6" lg="6" md="7" sm="12">
            <v-card class="mr-2 ml-2 card-login">
              <div
                class="mt-8 ml-3 mr-3 uppercase font-bold text-3xl"
                :class="$vuetify.theme.dark ? 'textwhite--text' : 'textblack--text'"
              >
                {{ $t('msg.login.signIn') }}
              </div>
              <div class="mt-10 ml-3 mr-3">
                <v-text-field
                  ref="usr_id"
                  v-model="login.usrId"
                  placeholder="Email Address"
                  dense
                  solo
                  maxlength="50"
                  hide-details
                  height="50"
                  class="login-field"
                  @keyup.enter="procLogin()"
                  autocomplete="off"
                ></v-text-field>
              </div>
              <div class="mt-7 ml-3 mr-3">
                <v-text-field
                  v-model="login.usrPwd"
                  ref="usr_pwd"
                  placeholder="Password"
                  type="password"
                  autocomplete="new-password"
                  dense
                  maxlength="100"
                  solo
                  hide-details
                  height="50"
                  class="login-field"
                  @keyup.enter="procLogin()"
                ></v-text-field>
              </div>
              <div class="pl-2 pr-3 pt-5 d-flex justify-space-between">
                <div class="mb-8 text-left">
                  <v-checkbox v-model="remember" hide-details class="mt-0">
                    <template v-slot:label>
                      <div class="ml-1 text-base font-semibold leading-snug textcolor4--text">
                        Remember me
                      </div>
                    </template>
                  </v-checkbox>
                </div>
                <div class="mt-1 text-right">
                  <a @click="$router.push('/forgotpassword')" class="textcolor4--text">
                    {{ $t('msg.login.forgotYourPassword') }}
                  </a>
                </div>
              </div>
              <div class="mt-5 pl-3 pr-3" style="margin-bottom: 13%">
                <v-btn
                  block
                  x-large
                  :color="$vuetify.theme.dark ? '#2D7ACA' : '#3DB6F3'"
                  @click="procLogin()"
                  class="sign-in"
                >
                  {{ $t('msg.login.signIn') }}
                </v-btn>
              </div>
              <div class="text-center" style="margin-bottom: 7%">
                <a
                  @click="$router.push('/createaccount')"
                  class="text-base font-semibold leading-snug textcolor4--text"
                >
                  {{ $t('msg.login.createAccount') }}
                </a>
                <span class="text-base leading-snug textcolor4--text">
                  {{ $t('msg.login.useSmartLink') }}
                </span>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="2" lg="2" md="1" sm="1"></v-col>
    </v-row>
    <v-row class="login-footer">
      <v-col cols="2" lg="2" md="1"></v-col>
      <v-col cols="8" lg="8" md="10">
        <div class="pt-5">
          <span
            class="text-sm leading-tight"
            :style="$vuetify.theme.dark ? 'color: #54565F;' : 'color: #C1C7D0'"
          >
            Copyright © {{ new Date().getFullYear() }} Cyberlogitec Co.Ltd. All rights reserved
          </span>
        </div>
      </v-col>
      <v-col cols="2" lg="2" md="1"></v-col>
    </v-row>
    <dialogWindow
      ref="LoginDialog"
      :info="checkDialogTitle"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="closeDialog()"
    >
    </dialogWindow>
    <dialogWindow
      ref="ResendEmailDialog"
      :info="checkDialogTitle"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      :showCancel="true"
      @select-ok="resendEmail()"
    >
    </dialogWindow>
    <dialogWindow
      ref="PasswordExpiredDialog"
      :info="checkDialogTitle"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="goResetPassword()"
    >
    </dialogWindow>
  </div>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import cfg from '@/vue-caas/config/config.js';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import { hideProgress } from '@/vue-dlb/utils/sys-util.js';
import loginCompleteMixin from '@/vue-caas/utils/login-complete-mixin.js';

export default {
  components: {
    dialogWindow,
    IconSvg,
  },

  mixins: [loginCompleteMixin],

  data: () => ({
    valid: true,
    login: {
      // usrId: 'person1@cyberlogitec.com',
      usrId: '',
      usrPwd: '',
    },
    // rules: {
    //   usrId: [
    //     v => !!v || 'Email Address is required',
    //   ],
    //   usrPwd: [
    //     v => !!v || 'Password is required',
    //   ],
    // },
    checkDialogColor: 'success',
    checkDialogTitle: '',
    checkDialogInfo: '',
    remember: false,
    isDlb: false,
    pwdNeverSet: false,
  }),

  created() {
    this.isDlb = cfg.isDlb;

    if (
      this.$cookies.get('ui-theme') === 'light' &&
      (!this.$vuetify.theme.light || this.$vuetify.theme.light === undefined)
    ) {
      this.$vuetify.theme.dark = false;
      this.$vuetify.theme.light = true;
    } else if (this.$cookies.get('ui-theme') === 'dark' && !this.$vuetify.theme.dark) {
      this.$vuetify.theme.dark = true;
      this.$vuetify.theme.light = false;
    }

    const rememberId = $cookies.get('remember-id');
    if (rememberId !== undefined && rememberId !== null) {
      this.remember = true;
      this.login.usrId = rememberId;
    } else {
      this.remember = false;
    }
  },

  mounted() {
    setTimeout(() => {
      if (this.remember) {
        this.$refs.usr_pwd.focus();
      } else {
        this.$refs.usr_id.focus();
      }
    }, 300);

    this.isLogout();
  },

  methods: {
    isLogout() {
      if (this.$route.query.status === 'logout') {
        // alert('logout');
        this.$refs.LoginDialog.dialog = true;
        this.checkDialogColor = 'information';
        this.checkDialogTitle = '';
        this.checkDialogInfo = this.$t('msg.login.expireSession');
      }
    },

    _setRememberId() {
      // At check remember id checkbox...
      if (this.remember) {
        // Cookie expired time unit
        // y: year
        // m: month
        // d: day
        // h: hour
        // min: minute
        // s: second
        // const expiredTime = '30s';
        const expiredTime = '7d';
        $cookies.set('remember-id', this.login.usrId, expiredTime);
      } else {
        $cookies.remove('remember-id');
      }
    },

    procLogin() {
      this._setRememberId();

      if (this.login.usrId === '') {
        this.$refs.LoginDialog.dialog = true;
        this.checkDialogColor = 'warning';
        this.checkDialogTitle = this.$t('msg.login.dialogTitleUser');
        this.checkDialogInfo = this.$t('msg.login.dialogInfoUser');
        return;
      }
      if (this.login.usrPwd === '') {
        this.$refs.LoginDialog.dialog = true;
        this.checkDialogColor = 'warning';
        this.checkDialogTitle = this.$t('msg.login.dialogTitlePassword');
        this.checkDialogInfo = this.$t('msg.login.dialogInfoPassword');
        return;
      }

      // alert(`User ID: ${this.login.usrId}\nUser Password: ${this.login.usrPwd}`);
      this.$store
        .dispatch('membership/login', this.login)
        .then((res) => {
          // OTP 2단계: 로그인 상태를 저장하지 않고 OTP 화면으로 이동
          if (res.mfaRequired) {
            this.$router.push('/otp');
            return;
          }
          if (res.otpLocked) {
            this.$refs.LoginDialog.dialog = true;
            this.checkDialogColor = 'warning';
            this.checkDialogTitle = '';
            this.checkDialogInfo = this.$t('msg.login.otpLocked');
            return;
          }
          if (res.pwdExpired) {
            this.pwdNeverSet = !!res.pwdNeverSet;
            this.$refs.PasswordExpiredDialog.dialog = true;
            this.checkDialogColor = 'warning';
            this.checkDialogTitle = '';
            this.checkDialogInfo = this.pwdNeverSet
              ? this.$t('msg.login.pwdNeverSet')
              : this.$t('msg.login.pwdExpired');
            return;
          }
          let authCd = res.authCd;
          if (authCd === 'W') {
            this.$refs.ResendEmailDialog.dialog = true;
            this.checkDialogColor = 'warning';
            this.checkDialogTitle = '';
            this.checkDialogInfo = this.$t('msg.login.validStatusConfirmUser');
          } else if (authCd === 'C') {
            this.$refs.LoginDialog.dialog = true;
            this.checkDialogColor = 'warning';
            this.checkDialogTitle = '';
            this.checkDialogInfo = this.$t('msg.login.validStatusApproveUser');
          } else {
            this.completeLogin();
          }
        })
        .catch((err) => {
          // alert(`error!!\n${err}`);
          this.$refs.LoginDialog.dialog = true;
          this.checkDialogColor = 'warning';
          this.checkDialogTitle = '';
          this.checkDialogInfo = this.$t('msg.login.validIdPass');
        });
    },

    closeDialog() {
      hideProgress();
      this.$refs.LoginDialog.dialog = false;
    },

    resendEmail() {
      let usrId = this.login.usrId;
      this.$router.push(`/resendemail/${usrId}`);
    },

    goResetPassword() {
      this.$router.push({
        path: `/changepassword/${this.login.usrId}`,
        query: { reason: this.pwdNeverSet ? 'neverset' : 'expired' },
      });
    },
  },
};
</script>

<style>
.login-form .v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
  height: auto !important;
}
.login-form {
  margin-top: -120px;
}
.card-login.v-card {
  padding: 8%;
  width: 100%;
  height: auto;
  top: 13vh;
  box-shadow: 0px 2px 30px rgba(0, 0, 0, 0.25) !important;
  border-radius: 10px;
}
.sign-in > .v-btn__content {
  font-weight: 700;
  font-size: 20px;
  line-height: 27px;
  text-transform: uppercase;
}
.login-field > .v-input__control {
  height: 50px !important;
}
.login-background {
  margin: 0;
  width: 100%;
  height: 75vh;
  background-position: top right;
}
.login-footer {
  width: 100%;
  height: 25vh;
  background-color: #191a21;
}
</style>
